import { render, staticRenderFns } from "./TheBackground.vue?vue&type=template&id=33b9359b&"
import script from "./TheBackground.vue?vue&type=script&lang=js&"
export * from "./TheBackground.vue?vue&type=script&lang=js&"
import style0 from "./TheBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports